import { render, staticRenderFns } from "./ChannelCreated.vue?vue&type=template&id=464f553e&scoped=true"
import script from "./ChannelCreated.vue?vue&type=script&lang=js"
export * from "./ChannelCreated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464f553e",
  null
  
)

export default component.exports